module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/ig-images/ig-07-c9323197ad654555e4e848bcf840153e.jpg";